import React, { Component } from 'react';
import Dialog               from 'material-ui/Dialog';
import FlatButton           from 'material-ui/FlatButton';
import browser              from 'detect-browser';
import PropTypes            from 'prop-types';

class GeoDialog extends Component
{
    state = {
        geoOpen: null
    };

    componentWillReceiveProps = () =>
    {
        this.setState({ geoOpen: null });
    };

    //---------------------------------------------------------------------------------------------------------------

    renderMessage = () =>
    {
        let message = 'We tried to enable location services in your browser so that we can notify you when you are near the places of interest showcased on this site. However, location services appear to be unavailable at the moment.';

        if ('safari' === browser.name)
        {
            message += ' If you are using a wired Internet connection try switching to wireless.'
        }

        return <div>
            <p>{ message }</p>
            <p>You may also want to try refreshing the browser and allowing the website to use your location.</p>
        </div>
    };

    //---------------------------------------------------------------------------------------------------------------

    isOpen = () =>
    {
        if (null !== this.state.geoOpen)
        {
            return this.state.geoOpen;
        }

        let { geo } = this.props;
        return (false === geo.informed && (false === geo.enabled || false === geo.available));
    };

    //---------------------------------------------------------------------------------------------------------------

    closeGeoModal = () =>
    {
        this.props.onClose();
        this.setState({ geoOpen: false });
    };

    //---------------------------------------------------------------------------------------------------------------

    render = () =>
    {
        let actions = [
            <FlatButton
                label="OK"
                primary={ true }
                onTouchTap={ this.closeGeoModal }
            />
        ];

        return (
            <Dialog
                title="We can't find your location"
                modal={ true }
                open={ this.isOpen() }
                actions={ actions }
            >
                { this.renderMessage() }
            </Dialog>
        );
    }
}

GeoDialog.propTypes = {
    geo    : PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default GeoDialog;


// WEBPACK FOOTER //
// ./src/components/Banner/GeoDialog.js